import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import {Link} from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import React, {useState} from "react";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import DataSaverOnIcon from "@mui/icons-material/DataSaverOn";
import DataSaverOffIcon from "@mui/icons-material/DataSaverOff";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {changeUserProfile} from "../app/userProfileSlice";
import {runUtility} from "../app/AppClient";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch} from "react-redux";
import EventNoteIcon from '@mui/icons-material/EventNote';
import ReleaseNotesDialogue from "./ReleaseNotes/ReleaseNotesDialogue";
import CoPresentIcon from '@mui/icons-material/CoPresent';

export default function AppMenuBarClusterRight({ setIsAuthenticated,  hideActions}) {

    const currentUserName = localStorage.getItem('userName');
    const currentUserRole = localStorage.getItem('role');
    const currentUserRights = localStorage.getItem('rights');
    const currentUserDepartment = localStorage.getItem('department');
    const currentUserFirstName = localStorage.getItem('firstName');
    const currentUserLastName  = localStorage.getItem('lastName');
    const [anchorEl, setAnchorEl] = React.useState(null);
    const isMenuOpen = Boolean(anchorEl);
    const [saveData, setSaveData] = useState(false);
    const [releaseNotesOpen, setReleaseNotesOpen] = useState(false);
    
    const menuId = 'primary-search-account-menu';

    const dispatchData = useDispatch();


    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleProfileMenuClose = () => {
        setAnchorEl(null);
    };




    function removeAuthentication() {
        setIsAuthenticated(false);
    };

    const handleClearUser = () => {
        localStorage.removeItem('token');  // Remove the token from local storage
        removeAuthentication();
        dispatchData(changeUserProfile({
            id: 0,
            firstName: null,
            lastName: null,
            department: null,
            role: null,
            status: null,
            rights: null,
            approvalLimit: null,
            userName: null,
            createdOn: null,
            createdBy: null,
            lastModifiedOn: null,
            lastModifiedBy: null
        }));}



    const handleSequence = () => {
        console.log("sequencing started");
        setSaveData(!saveData);

        runUtility('sequence').then(() => {
            console.log("sequencing ended");
            setSaveData(false);
        });
    };


    const handleReleaseNotes = () => {
        setReleaseNotesOpen(true);
    };

    const handleCloseReleaseNotes = () => {
        setReleaseNotesOpen(false);
    };



    const handleAdmin = () => {
        // setReleaseNotesOpen(true);
    };

    return (

        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>

            <Tooltip title={"Release Notes"}>
                <IconButton size="large" aria-label="rel notes" color="inherit"
                            style={{cursor:'pointer'}}   onClick={() => handleReleaseNotes()}>
                    <EventNoteIcon/>
                </IconButton>
            </Tooltip>
            <Tooltip title={"Batch"}>
                <IconButton size="large" aria-label="track data" color="inherit"
                            component={Link} to={"/Batch"}>
                    <AutoAwesomeMotionIcon/>
                </IconButton>
            </Tooltip>
            <Tooltip title={"Resequence"}>
                <IconButton size="large" aria-label="track data" color="inherit"
                            onClick = {handleSequence} >
                    {saveData && <DataSaverOnIcon/>}
                    {!saveData && <DataSaverOffIcon/>}
                    {/*</Badge>*/}
                </IconButton>
            </Tooltip>
            <Tooltip title={"Admin"}>
                <IconButton size="large" aria-label="admin" color="inherit"
                            // style={{cursor:'pointer'}}   onClick={() => handleAdmin()}
                            component={Link} to={"/admin"}
                >
                    <CoPresentIcon/>
                </IconButton>
            </Tooltip>
            <Box>
            <Tooltip title= {currentUserName}>
                <IconButton
                    size="large"
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={menuId}
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                    color="inherit"
                >
                    <AccountCircle />
                </IconButton>
            </Tooltip>
                {/*const renderMenu = (*/}
                <Menu
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    id={menuId}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={isMenuOpen}
                    onClose={handleProfileMenuClose}
                >

                    <MenuItem ></MenuItem>
                    <MenuItem >Current User: {currentUserFirstName} {currentUserLastName}</MenuItem>
                    <MenuItem >UserName: {currentUserName}</MenuItem>
                    <MenuItem >Department: {currentUserDepartment}</MenuItem>
                    <MenuItem >Role: {currentUserRole}</MenuItem>
                    <MenuItem >Rights: {currentUserRights} </MenuItem>
                    <MenuItem ></MenuItem>
                    <MenuItem onClick = {handleClearUser}  component={Link} to="/">Log Out</MenuItem>
                    <MenuItem ></MenuItem>
                    {!hideActions &&
                        <MenuItem
                            component={Link} to={"/users"}
                        onClick={handleProfileMenuClose}
                        >User List</MenuItem>
                    }
                </Menu>
            </Box>
            <ReleaseNotesDialogue
                open={releaseNotesOpen}
                onClose={handleCloseReleaseNotes}
            />
        </Box>
    )

}